import { useSelector } from 'react-redux';

export default function useRefreshTick() {
  return useSelector((s) => s.cloud?.refreshTick ?? 0);
}
